import React from 'react'
import Accueil from "../Accueil";
import Home from "../Home";

export default function LayoutHome( props ) {
 return (
    <>
        <Home />
    </>
 )}